import { createFollowProject } from "@/api/endpoint/project/create-follow-project";
import Button from "@/components/Button";
import MeeyImage from "@/components/MeeyImage";
import PopOver from "@/components/PopOver";
import { FOLLOW_PROJECT_STATUS } from "@/constants/common-constant";
import { CommentTypeEnum } from "@/constants/enum/comment";
import { APP_BASE_URL, STATIC_DOMAIN } from "@/constants/environment";
import { DEFAULT_LOGO_PROJECT } from "@/constants/project-constant";
import { ProjectContext } from "@/context/project.context";
import { useAuth } from "@/hooks/useAuth";
import InputSearchReview from "@/modules/common/ProjectDetail/InputSearchReview";
import ShareButton from "@components/Share";
import { ProjectReview } from "Models";
import { useRouter } from "next/router";
import { useContext, useState } from "react";
import urlJoin from "url-join";

import dynamic from "next/dynamic";
const ModalAddReviewProjectDetail = dynamic(
  import("./ModalAddReviewProjectDetail"),
  {
    ssr: false,
  }
);

interface IHeaderProjectScroll {
  project: ProjectReview;
  isFollowProject?: boolean;
}

const HeaderProjectScroll = ({
  project,
  isFollowProject,
}: IHeaderProjectScroll) => {
  const [openModalReview, setOpenModalReview] = useState(false);
  const [reviewType, setReviewType] = useState(CommentTypeEnum.REVIEW);
  const { setCheckFollowProject } = useContext(ProjectContext);
  const { asPath } = useRouter();

  const { token, login } = useAuth();
  const handleFollowProject = async () => {
    if (!token) {
      login();
    } else {
      const res = await createFollowProject(
        {
          project: project?._id,
          status: isFollowProject
            ? FOLLOW_PROJECT_STATUS.UN_FOLLOW
            : FOLLOW_PROJECT_STATUS.FOLLOW,
        },
        token
      );
      if (res) {
        setCheckFollowProject(!isFollowProject);
      }
    }
  };

  return (
    <div className="w-full h-fit bg-white shadow-light-1">
      <div className="flex items-center justify-between gap-6 py-2 layout">
        <div className="flex items-center gap-2">
          <MeeyImage
            src={
              project?.logo
                ? project?.logo?.uri
                : `${STATIC_DOMAIN}/${DEFAULT_LOGO_PROJECT}`
            }
            alt={project?.title}
            resizeOnFly={!!project?.logo?.uri}
            resizeOptions={{
              width: 0,
              height: 36,
            }}
            className="rounded-full h-9 w-9 border-2 border-solid border-grey-50 object-contain"
          />
          <PopOver
            trigger="hover"
            dropdownClassName="mt-2 !p-0 rounded !bg-transparent"
            content={
              <div className="py-1 px-2 bg-black-800 text-fs-14 text-white max-w-[30rem] break-word">
                {project?.title}
              </div>
            }
            position="bottom-left">
            <span className="text-fs-16 font-semibold text-grey-700">
              {project?.title?.length > 80
                ? project?.title.substring(0, 80) + "..."
                : project?.title}
            </span>
          </PopOver>
        </div>
        {project?.totalHotReview ? (
          <div className="flex items-center gap-2">
            {project?.voteScore ? (
              <div className="flex items-center gap-1">
                <div className="text-fs-20 font-semibold text-grey-700">
                  {Number.isInteger(project?.voteScore)
                    ? project?.voteScore
                    : project?.voteScore?.toFixed(1)}
                </div>
                <i className="mrv mrv-star text-[#FFC633] text-fs-20"></i>
              </div>
            ) : null}

            <span className="text-fs-16 text-grey-700">
              ({project?.totalHotReview} reviews)
            </span>
          </div>
        ) : null}
      </div>
      <div className="border-t border-solid border-grey-100">
        <div className="py-2 flex items-center justify-between layout">
          <InputSearchReview />
          <div className="flex items-center gap-4">
            {openModalReview ? (
              <ModalAddReviewProjectDetail
                open={openModalReview}
                handleClose={() => setOpenModalReview(false)}
                project={project}
                reviewType={reviewType}
              />
            ) : null}
            <Button
              color="primary"
              btnType="filled"
              onClick={() => {
                setOpenModalReview(true);
                setReviewType(CommentTypeEnum.REVIEW);
              }}
              className="!h-9"
              prefixIcon={<i className="mrv mrv-review text-fs-18"> </i>}>
              Viết review
            </Button>
            <Button
              className="meey-button meey-button-filled !bg-purple-500 hover:!text-white py-2.5 px-4 h-9 flex items-center gap-1 !border-none"
              onClick={() => {
                setOpenModalReview(true);
                setReviewType(CommentTypeEnum.QUESTION);
              }}>
              <i className="mrv mrv-contact_support text-fs-18"></i>
              <span className="text-fs-14 font-semibold">Đặt câu hỏi</span>
            </Button>
            <PopOver
              trigger="hover"
              dropdownClassName="mt-2 !p-0 rounded !bg-transparent"
              content={
                !isFollowProject ? (
                  <div className="py-1 px-2 bg-black-800 text-fs-14 text-white max-w-[30rem] break-word">
                    “Hóng” sẽ giúp bạn cập nhật liên tục review mới của dự án
                    này!
                  </div>
                ) : null
              }
              position="bottom-left">
              <Button
                className="meey-button meey-button-grey meey-button-filled py-2.5 px-4 h-9 flex items-center gap-1"
                onClick={handleFollowProject}>
                <i className="mrv mrv-hearing text-fs-18"></i>
                <span className="text-fs-14 font-semibold">
                  {isFollowProject ? "Đã hóng" : "Hóng"}
                </span>
              </Button>
            </PopOver>

            <ShareButton shareUrl={urlJoin(APP_BASE_URL, asPath)}>
              <Button className="meey-button meey-button-grey meey-button-filled h-9 w-9 flex items-center justify-center">
                <i className="mrv mrv-share text-fs-18"></i>
              </Button>
            </ShareButton>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeaderProjectScroll;
